<template>
  <div>
    <input
      v-model="email"
      pattern="^[a-zA-Z_0-9\-'\+~]+(\.[a-zA-Z_0-9\-'\+~]+)*@([a-zA-Z_0-9\-]+\.)+[a-zA-Z]{2,7}$"
      title="Invalid email"
      type="email"
      class="nissan-quiz-input"
      id="nissan-quiz-email"
      name="email"
      placeholder="e-mail"
      required />
  </div>
</template>


<script>

export default {
  name: 'UserLookup',
  computed: {
    email: {
      get() {
        return this.$store.state.email;
      },
      set(value) {
        this.$store.commit('setEmail', { value });
      },
    },
  },
};
</script>


<style scoped lang="scss">
@import '../../styles/_variables.scss';
@import '../../styles/_reset.scss';


input.nissan-quiz-input {
  position: relative;
  display: block;
  background-color: transparent;
  border: 2px solid #FFF;
  width: 90%;
  color: #FFF;
  font-size: 16px;
  height: 30px;
  text-align: center;
  font-weight: bold;
  line-height: 18px;
  text-transform: uppercase;
  margin: 5px auto 0;
  padding: 8px 0;
  &::placeholder {
    color: #fff;
  }
}
@media only screen and (min-width: 600px) {
  input.nissan-quiz-input {
    height: 45px;
  }
}
</style>
